import { useQueryData } from "@src/hooks/useQueryData";
import { wsDepotCardsServices } from "../../../../../api/wsDepotCards";
import { wsInplantsServices } from "../../../../../api/wsInplants";

export function useWsInplantContentDetailQuery(params: {
    mode: "create" | "edit";
    contentCode?: number;
    inplantCode: number;
}) {
    const { mode, contentCode, inplantCode } = params;

    return useQueryData({
        queryKey: ["workshop", "wsInplant", "content", contentCode],
        queryFn: async () => {
            if (contentCode == null) {
                throw new Error("Не определён код элемента состава ВЗН");
            }

            const items = await wsInplantsServices.content.load({
                flt: { WsInplantCode: inplantCode, Codes: [contentCode] },
                include: ["LeaveCard", "Order"],
                includeLeaveCard: ["Stockobj", "Measure", "ProductionType"],
            });

            if (items.length === 0) {
                throw new Error("Элемент состава ВЗН не найден");
            }

            return items[0];
        },
        enabled: mode === "edit" && contentCode != null && contentCode > 0,
        meta: { errorSource: "workshop.wsInplant.content.detail" },
    });
}

export function useWsDepotCardResolveQuery(leaveCardCode: number | null | undefined) {
    return useQueryData({
        queryKey: ["workshop", "wsDepotCard", "resolve", leaveCardCode],
        queryFn: async () => {
            if (leaveCardCode == null || leaveCardCode <= 0) {
                return null;
            }

            return wsDepotCardsServices.loadOne({
                flt: { Codes: [leaveCardCode] },
                include: ["Stockobj", "Measure", "ProductionType"],
            });
        },
        enabled: leaveCardCode != null && leaveCardCode > 0,
    });
}
